import React from 'react';
import buttonImage from '../buttonimage.webp';
import backgroundImage from '../background.webp';
import cardBackgroundImage from '../cardbackground.webp';
import WorksheetCard from '../WorksheetCard';

function Gratitude({ goBack, goHome, handleSaveProgress }) {
    const handleSave = async () => {
        if (typeof handleSaveProgress === 'function') {
            await handleSaveProgress('gratitude', null, false);
            alert('Session progress has been saved successfully!');
        }
    };

    return (
        <div style={{
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '16px',
        }}>
            {/* Title */}
            <h3 style={{
                fontFamily: 'Times New Roman, Times, serif',
                fontSize: '24px',
                fontWeight: 'bold',
                color: 'black',
                marginBottom: '32px',
            }}>
                Gratitude
            </h3>

            {/* Session Helper Cards Row */}
            <div
                className="gratitude-session-helper-row"
                style={{
                    display: 'flex',
                    flexDirection: window.innerWidth <= 600 ? 'column' : 'row',
                    gap: '16px',
                    width: '100%',
                    maxWidth: '600px',
                    marginBottom: '16px',
                }}
            >
                {/* Left Card */}
                <div style={{
                    flex: 1,
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'left',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    marginBottom: window.innerWidth <= 600 ? '16px' : 0,
                }}>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'center' }}>*Session Helper*</div>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                        <div>• Being in Gratitude is a high vibrational state</div>
                        <div>• Gratitude feels good</div>
                        <div>• Nothing is too small to be grateful for</div>
                        <div>• Gratitude is just a deep felt appreciation</div>
                        <div>• If needed start small with Gratitude. It gets easier!</div>
                        <div>• There is always something to be Grateful for</div>
                    </div>
                </div>
                {/* Right Card */}
                <div style={{
                    flex: 1,
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'left',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }}>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'center' }}>*Session Helper*</div>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                        <div>Can you easily name something you are grateful for?</div>
                        <div>2. Is gratitude a daily practice for you?</div>
                        <div>3. Have you noticed how you feel when you are in Gratitude? </div>
                        <div>4. Can you be grateful even when things do not go your way?</div>
                        <div>5. Have you ever been feeling so much gratitude that you produced tears?</div>
                        <div>6. What are you Grateful for today?</div>
                    </div>
                </div>
            </div>

            {/* WorksheetCard Section */}
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '16px',
                width: '100%',
                maxWidth: '600px',
                marginBottom: '24px',
            }}>
                <WorksheetCard title="Gratitude Worksheet" columnName="gratitude" />
            </div>

            {/* Cards */}
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '16px',
                width: '100%',
                maxWidth: '600px',
            }}>
                {/* Card 1 */}
                <div style={{
                    width: '100%',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }}>
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        color: 'black',
                    }}>
                        Gratitude is the better feeling thought. I have spent segments of time consciously redirecting my attention toward gratitude every time I noticed myself thinking negatively.  As a result it comes more naturally to me now. 
                    </p>
                </div>

                {/* Card 2 */}
                <div style={{
                    width: '100%',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }}>
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        color: 'black',
                    }}>
                        I also spent time early on in my transformative journey to start each day with recognizing something I am grateful for.  This was a way to start shifting the habit I was in of thinking negatively.  
                    </p>
                </div>

                {/* Card 3 */}
                <div style={{
                    width: '100%',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }}>
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        color: 'black',
                    }}>
                        Explore ways to cultivate gratitude in your daily life. Embracing challenges can be an untapped way of tapping into Gratitude.  When challenges lead to personal growth that is something to be grateful for!
                    </p>
                </div>
            </div>

            {/* Navigation Buttons */}
            <div
                className="gratitude-nav-btn-row"
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '16px',
                    marginTop: '32px',
                    marginBottom: '16px',
                }}
            >
                <button style={{
                    backgroundImage: `url(${buttonImage})`,
                    backgroundSize: 'cover',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '10px 20px',
                    width: '120px',
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }} onClick={goBack}>Back</button>
                <button style={{
                    backgroundImage: `url(${buttonImage})`,
                    backgroundSize: 'cover',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '10px 20px',
                    width: '120px',
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }} onClick={goHome}>Home</button>
                <button style={{
                    backgroundImage: `url(${buttonImage})`,
                    backgroundSize: 'cover',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '10px 20px',
                    width: '120px',
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }} onClick={handleSave}>Save</button>
            </div>
            <style>
                {`
                @media (max-width: 600px) {
                    .gratitude-nav-btn-row {
                        position: static !important;
                        width: 100%;
                        background: none;
                        border-top: none;
                        border-radius: 0;
                        box-shadow: none;
                        padding: 0;
                        z-index: auto;
                        display: flex;
                        justify-content: center;
                        gap: 10px;
                        margin-top: 32px !important;
                        margin-bottom: 16px !important;
                    }
                    body {
                        padding-bottom: 0 !important;
                    }
                }
                `}
            </style>
        </div>
    );
}

export default Gratitude;